/**
 * @generated SignedSource<<9902b78192ab814dac863dbc2d327ad7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventOverviewPageDescriptionsFragment$data = {
  readonly about: string | null | undefined;
  readonly audienceGroups: {
    readonly totalCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"AudienceGroupsFragment">;
  };
  readonly gettingStarted: string | null | undefined;
  readonly host: {
    readonly events: {
      readonly totalCount: number;
    };
    readonly " $fragmentSpreads": FragmentRefs<"HostCardFragment">;
  };
  readonly purpose: string | null | undefined;
  readonly rewardCount: {
    readonly totalCount: number;
  };
  readonly timeline: {
    readonly " $fragmentSpreads": FragmentRefs<"TimelineFragment">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"EventCompetitionsCarouselFragment" | "RewardsFragment" | "TagListFragment">;
  readonly " $fragmentType": "EventOverviewPageDescriptionsFragment";
};
export type EventOverviewPageDescriptionsFragment$key = {
  readonly " $data"?: EventOverviewPageDescriptionsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventOverviewPageDescriptionsFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v1 = [
  (v0/*:: as any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventOverviewPageDescriptionsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "about",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "purpose",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gettingStarted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Timeline",
      "kind": "LinkedField",
      "name": "timeline",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TimelineFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AudienceGroupConnection",
      "kind": "LinkedField",
      "name": "audienceGroups",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AudienceGroupsFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "rewardCount",
      "args": null,
      "concreteType": "RewardConnection",
      "kind": "LinkedField",
      "name": "rewards",
      "plural": false,
      "selections": (v1/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "host",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HostCardFragment"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 0
            }
          ],
          "concreteType": "EventConnection",
          "kind": "LinkedField",
          "name": "events",
          "plural": false,
          "selections": (v1/*:: as any*/),
          "storageKey": "events(first:0)"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RewardsFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TagListFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventCompetitionsCarouselFragment"
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "32e44b886a4f3cd91b7958188fe4fab8";

export default node;
